import { Component, Input, OnChanges, SimpleChanges } from '@angular/core'
import { Sale } from '../../models'

@Component({
  selector: 'se-po-related-orders-card',
  templateUrl: './related-orders-card.component.html',
  styleUrls: ['./related-orders-card.component.css'],
  standalone: false,
})
export class RelatedOrdersCardComponent implements OnChanges {
  @Input() public order: Sale | null = null
  @Input() public type = ''
  public childLinks: string[] = []
  public parentLink: string | null = null

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.order || changes.type) {
      this.getLinks()
    }
  }

  public getLinks(): void {
    const baseUrl = window.location.origin

    this.childLinks = []
    this.parentLink = null

    if (this.order?.child_sales?.length > 0) {
      const linkPrefix = this.type === 'order' ? '/user/orders/' : '/user/bills/'
      this.childLinks = this.order.child_sales.map(child => `${baseUrl}${linkPrefix}${child.sale_number}`)
    }

    if (this.order?.parent_sale) {
      const linkPrefix = this.type === 'order' ? '/user/orders/' : '/user/bills/'
      this.parentLink = `${baseUrl}${linkPrefix}${this.order.parent_sale.sale_number}`
    }
  }
}
